import { createFileRoute } from "@tanstack/react-router";

import { ForgotPasswordForm } from "@/components/auth/forgot-password-form";
import { noIndexSeo } from "@/lib/seo";

export const Route = createFileRoute("/(landing)/(auth)/forgot-password")({
	component: RouteComponent,
	head: ({ match }) =>
		noIndexSeo({
			title: "Forgot Password | StudyOS",
			description: "Request a password reset link for your StudyOS account.",
			pathname: match.pathname,
		}),
});

function RouteComponent() {
	return (
		<div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
			<div className="w-full max-w-sm">
				<ForgotPasswordForm />
			</div>
		</div>
	);
}
